import { UPDATE_SM_INIT } from '../../common/actions';
import { GET_AUTORESP_DATA} from './types';
import { HiverAxios, unsavedChanges, showMessage } from 'h-commons';
const SM_ROOT = '/api/sm';

/**
 * Returns type of message
 * @param {String} type 
 */
function getMessage(type) {
    if (type === "edit") {
        return "Auto Responder text edited";
    }
    return "Auto Responder enabled";
}

/**
 *  preparing request data that need to be send to sever
 */
const getRequestObject = (autoRespData) => {
    const { all, bh, nonBh,editorData,exclusionList} = autoRespData;
    let reqstObj = {};
   

    if (all && autoRespData['all'].enabled && autoRespData['all'].content.length > 0) {
        const enabled = (autoRespData.responseHourType == 1) ? 1 : 0;
        reqstObj['all'] = {
                content: all.content,
                enabled: enabled
            };
    }
  
    if (bh &&  autoRespData['bh'].content.length > 0) {
        const enabled = (autoRespData.responseHourType == 2) ? bh.enabled : 0;
        reqstObj['bh'] = {
                content: bh.content,
                enabled:enabled
            };
    }

    if (nonBh && (autoRespData['nonBh'].content.length > 0 || editorData.length > 0)) {
        const enabled = (autoRespData.responseHourType == 2) ? nonBh.enabled : 0;
        reqstObj['non-bh']  = {
                content: nonBh.content || editorData,
                enabled
            };
    }

    if(exclusionList?.length > 0){
        reqstObj['exclusion-list'] = exclusionList
    }

    return reqstObj;
}

/**
 * Responsible for saving auto responder for the loggedin user
 */
export function autoRespSave(smid, contentData) {
   
    return (dispatch) => {
        dispatch({ type: UPDATE_SM_INIT });
        const type = "edit";
       const reqstObj = getRequestObject(contentData);

        HiverAxios({
            url: `${SM_ROOT}/${smid}/autoresponders`,
            type: 'post',
            params: reqstObj,
            callback: (response) => {

                if (response.status !== 200) {
                    showMessage({ message: 'Unable to save, maximum 65,000 characters supported', type: 'error' })
                    return;
                }
                dispatch(unsavedChanges(false));
                showMessage({ message: getMessage(type), type: 'success' })
                response.data['smid']= smid;
                dispatch({
                    type: GET_AUTORESP_DATA,
                    payload:response.data
                });
            },
            onfail: () => {
                showMessage({ message: 'Unable to save, maximum 65,000 characters supported', type: 'error' });
            }
        });
    };
}
